<template>
  <div>
    <template v-if="!ClientContractID || !ClientContractID.id">
        <div class="d-flex align-items-center justify-content-center" style="height: calc(100vh - 57px);">
            <h2 class="text-danger">Please choose a contract to load the location.</h2>
        </div>
    </template>
    <div v-else class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
      <div class="boxShadow setBorderRadius heig-frame-equipment-group">
        <b-row no-gutters>
          <b-col md="12" class="heig-frame-child">
            <gofix-card class="mb-0 heig-frame-child" fullContent>
              <gofix-default-table :settings="tableConfig"
                  :table-items="tableItems"
                  :tbody-tr-class="rowClass"
                  @new-item="newItem"
                  @row-click="clickToRowItem"
                  @load-items="getTableData"
                  ref="gofixTable">
                  <!-- <template slot="gofix_table:equipments" slot-scope="row">
                    <a :class="['control-item-link cursor-pointer mr-3']" @click.stop="showModalEquipment(row.item, null)">
                      <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                      </svg>
                    </a>
                    <template v-if="row.item.equipments && row.item.equipments.length">
                      <span @click.stop="showModalEquipment(row.item, item)" class="control-item-link cursor-pointer" v-for="(item, index) in row.item.equipments" :key="index">
                        <template v-if="item.custom_fields_web && item.custom_fields_web.length">
                          <u>{{ item.custom_fields_web[0].value ? item.custom_fields_web[0].value : 'N/A' }}</u>
                          <template v-if="index != row.item.equipments.length - 1">, </template>
                        </template>
                      </span>
                    </template>
                  </template> -->
              </gofix-default-table>
            </gofix-card>
          </b-col>
        </b-row>
      </div>

      <b-modal :no-close-on-backdrop="true" id="modal-create-orders" :title="`${this.modals.create.data.id ? 'Edit' : 'Add'} Location`" hide-footer :centered="true" v-model="modals.create.open" ref="modal-create-orders">
        <b-form class="formV2 formNLTProperty">
          <!-- <b-row align-v="center" class="mb-26">
            <b-col :md="!this.modals.create.data.id ? 8 : 12">
              <gofix-form-input-number
                label="Enter 6-digit Postal Code"
                class="mb-0"
                required
                show-icon-required
                :decimalLimit="0"
                :allowDecimal="false"
                thousandsSeparatorSymbol=""
                :integerLimit="6"
                :disabled="modals.create.data.id ? true : false"
                v-model="modals.create.data.postal_code">
              </gofix-form-input-number>
            </b-col>
            <b-col md="4" v-if="!this.modals.create.data.id">
              <gofix-button label="Check" :disabled="modals.create.isCheckLoading || (!modals.create.data.postal_code || modals.create.data.postal_code.length < 6)" :loading="modals.create.isCheckLoading" @click="checkExistingPostalCode"></gofix-button>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col md="12">
              <!-- <gofix-form-dropdown 
                vLabel="name"
                label="Select Parent Node" 
                required
                show-icon-required
                :filterable="false" 
                :disabled="modals.create.isSave || (modals.create.data.id ? true : false)"
                :clearable="!modals.create.isSave"
                :options="modals.options.properties" 
                v-model="modals.create.data.parent" 
                @search="searchProperty"
                ref="parentNode">
              </gofix-form-dropdown> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <gofix-form-input 
                label="Location Name"
                required
                show-icon-required
                :disabled="modals.create.isSave"  
                v-model="modals.create.data.name">
              </gofix-form-input>
            </b-col>
            <!-- <b-col md="12">
              <gofix-form-input 
                label="Enter Block Number/House Number"
                required
                show-icon-required
                maxlength="6"
                :disabled="modals.create.isSave"  
                v-model="modals.create.data.street_no">
              </gofix-form-input>
            </b-col>
            <b-col md="12">
              <gofix-form-input 
                label="Enter Street Name"
                required
                show-icon-required
                :disabled="modals.create.isSave"  
                v-model="modals.create.data.street_name">
              </gofix-form-input>
            </b-col> -->
            <b-col md="12">
              <gofix-form-dropdown
                label="Select Property Type"
                vLabel="reference_value_text"
                required
                show-icon-required
                :disabled="modals.create.isSave" 
                :clearable="!modals.create.isSave"
                v-model="modals.create.data.property_type"
                :options="modals.options.property_types">
              </gofix-form-dropdown>
            </b-col>
            <b-col md="12">
              <gofix-form-input :disabled="modals.create.isSave" label="Latitude" v-model="modals.create.data.geo_location.latitude"></gofix-form-input>
              <gofix-form-input :disabled="modals.create.isSave" label="Longtitude" v-model="modals.create.data.geo_location.longtitude"></gofix-form-input>
            </b-col>
          </b-row>
        </b-form>
        <b-button-group class="d-block text-right pr-4">
          <gofix-button v-if="modals.create.data.id" label="DELETE" @click="modals.confirm.open = true" :disabled="!this.$checkRole(this.$accessModule.safety_app_location, 'delete')" noBorder></gofix-button>
          <gofix-button label="SUBMIT" :loading="modals.create.loading" @click="save" :disabled="modals.create.isSave || (!modals.create.data.name || !modals.create.data.property_type)" noBorder></gofix-button>
        </b-button-group>
      </b-modal>
      <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.confirm.open">
        <div class="center">Are you sure you want to <br/>delete <strong>This Item</strong>?</div>
        <b-button-group class="btn-group">
          <b-button class="custom-btn" @click="modals.confirm.open = false">Cancel</b-button>
          <b-button class="custom-btn" @click="deleteProperty" :disabled="modals.confirm.loading">
              <b-spinner v-if="modals.confirm.loading" small type="grow"></b-spinner>Confirm
          </b-button>
        </b-button-group>
      </b-modal>

      <modal-add-equipment :tree-selected="modals.equipment.data" :info="modals.equipment.data" @groupSelected="onGroupSelected" @reloadList="$refs.gofixTable.reloadTableItems()" v-model="modals.equipment.open"></modal-add-equipment>
    </div>
  </div>
</template>
<script>
import { filters } from '@/_filterVar.js'
import { mapGetters } from 'vuex';
const modalAddEquipment = () => import('./modal-add-equipment')

export default {
  name: 'safety-properties',
  components: {
    modalAddEquipment
  },
  data() {
    let filter =  JSON.parse(JSON.stringify(filters['safety_location']));
    return {
      tableConfig:{
        name: 'safety-location-listing',
        controls:{
          delete: false,
          create: this.$checkRole(this.$accessModule.safety_app_location, 'create'),
          tableImport: false,
          tableExport: false
        },
        filter: filter,
        page: 1,
        limit: 100,
        total: 0,
        useDatabaseView: false,
        sortColumn: "id",
        sortDirection: "desc",
      },
      tableItems:[],
      modals:{
        options: {
          properties: [],
          property_types: []
        },
        create:{
          open: false,
          isSave: false,
          isCheckLoading: false,
          loading: false,
          data: {
            id: null,
            // street_name: null,
            // street_no: null,
            property_type: null,
            // postal_code: null,
            // parent: null,
            contract_id: null,
            geo_location: {
              latitude: null,
              longtitude: null
            },
            name: null
          }
        },
        confirm: {
          open: false,
          loading: false
        },
        equipment: {
          open: false,
          is_existing_group_lift: false,
          data: {
            groups: null,
            location: null
          }
        }
      },
      timer: {
        properties: null,
        check: null,
        save: null,
        delete: null
      }
    }
  },
  computed: {
    ...mapGetters({
      ClientContractID: 'ContractController/ClientContractID',
    })
  },
  watch: {
    ClientContractID: function() {
      if(this.$refs.gofixTable)
        this.$refs.gofixTable.reloadTableItems();
    }
  },
  created () {
  },
  methods: {
    rowClass(item) {
      if (item) {
        if (!item.is_safety) {
            return 'bg-gray-e9e';
        }
      }
      return null;
    },
    async getTableData(callback){
      const { tableRequest , resolve,reject } = await callback();
      if(!this.ClientContractID || !this.ClientContractID.property_root_id) {
        this.tableItems = [];
        this.tableConfig.total = 0;
        resolve({
          items: [],
          total: 0
        });
        return;
      }
      tableRequest.filter.property_root_id.value = this.ClientContractID.property_root_id
      await this.$store.dispatch("SafetyAppController/getListLocations", tableRequest)
        .then(response => {
          this.tableItems = response.items;
          this.tableConfig.total = response.total;
          resolve(response);
        })
        .catch(err => {
          this.$alertNotification("Can not load the data", "danger");
          reject();
        })
    },
    async newItem() {
      if(!this.ClientContractID || !this.ClientContractID.id) {
        return this.$alertNotification("Please select contract selector", "danger");
      }

      this.modals.create.isSave = false
      this.modals.create.data = Object.assign(this.modals.create.data, {
        id: null,
        // street_name: null,
        // street_no: null,
        property_type: null,
        // postal_code: null,
        // parent: null,
        contract_id: this.ClientContractID.id,
        geo_location: {
          latitude: null,
          longtitude: null
        },
        name: null
      });

      this.searchProperty('', () => {})
      await this.getReferences()
      this.modals.create.open = true
    },
    async clickToRowItem(item) {
      if(!this.$checkRole(this.$accessModule.safety_app_location, 'update') || !item.is_safety) return
      this.modals.create.isSave = false
      let response = await global.axios(`api/contracts/${this.ClientContractID.id}/properties/${item.id}`, {
          method: "GET",
          headers: {
              Accept: "application/json",
          }
      });

      const property = await response.data.data;
      let arr_tmp = property.root_path.split(" >> ");
      let parent_name = '';
      if(arr_tmp.length >= 2) {
        parent_name = arr_tmp[arr_tmp.length - 2];
      }
      this.modals.create.data = await Object.assign(this.modals.create.data, {
        id: item.id,
        // street_name: property.get_address.street_name,
        // street_no: property.get_address.street_no,
        property_type: property.property_type,
        // postal_code: property.get_address.postal_code,
        // parent: {
        //   id: property.parent_id,
        //   name: parent_name
        // },
        contract_id: this.ClientContractID.id,
        geo_location: property.get_address && property.get_address.geo_location ? property.get_address.geo_location : {
          latitude: null,
          longtitude: null
        },
        name: property.name
      });

      this.getReferences()
      this.modals.create.open = true
    },
    async getReferences() {
      await this.$store.dispatch(`PropertyController/getReferences`, {
        filter: { reference_type: 'Property Type' },
        limit: -1,
        isCMS: true
      })
      .then(response => {
        this.modals.options.property_types = response.data.data.items;

        const uniqueData = [];
        const uniqueValues = new Set();

        response.data.data.items.forEach(item => {
          if (!uniqueValues.has(item.reference_value_text)) {
            uniqueValues.add(item.reference_value_text);
            uniqueData.push(item);
          }
        });

        this.modals.options.property_types = uniqueData
      })
    },
    searchProperty(search, loading) {
      this.modals.options.properties = []
      loading(true);
      if (this.timer.properties) {
          clearTimeout(this.timer.properties);
          this.timer.properties = null;
      }
      this.timer.properties = setTimeout(() => {
        this.$store.dispatch('PropertyController/getSearchProperties', {
            keyword: search,
            property_root_id: this.ClientContractID.property_root_id,
            parent_id: this.ClientContractID.property_root_id,
            limit: 100,
            is_active: true,
          })
          .then(response => {
            this.modals.options.properties = response
            loading(false);
          })
          .catch(err => {
            loading(false);
          })
      }, 500);
    },
    checkExistingPostalCode() {

      if(!this.modals.create.data.postal_code) {
        return this.$alertNotification("Postal code is required", "danger");
      }

      if (this.timer.check) {
        clearTimeout(this.timer.check);
        this.timer.check = null;
      }
      this.timer.check = setTimeout(() => {
        if(this.modals.create.isCheckLoading) return
        this.modals.create.isCheckLoading = true

        let params = {
          postal_code: this.modals.create.data.postal_code,
          parent_id: this.ClientContractID.property_root_id
        }

        this.$store.dispatch('SafetyAppController/checkExistingPostalCode', params)
        .then(response => {
          this.modals.create.isCheckLoading = false
          this.modals.create.data.parent = this.modals.create.data.street_no = this.modals.create.data.street_name = this.modals.create.data.property_type = null
          if(response.data.data.existing) {
            this.modals.create.isSave = true
            if(response.data.data.property) {
              const property = response.data.data.property
              this.modals.create.data.property_type = property.property_type
              this.modals.create.data.parent = property.parent

              if(property.get_address) {
                if(property.get_address.street_no) {
                  this.modals.create.data.street_no = property.get_address.street_no
                }
                if(property.get_address.street_name) {
                  this.modals.create.data.street_name = property.get_address.street_name
                }
              }

              if(!this.modals.create.data.street_no || !this.modals.create.data.street_name) {
                const arrTmp = property.name.split(' ');
                if(arrTmp.length > 1) {
                  if(!this.modals.create.data.street_no) this.modals.create.data.street_no   = arrTmp[0].replace(',', '');
                  if(!this.modals.create.data.street_name) this.modals.create.data.street_name = arrTmp[1].replace(',', '');
                }
              }
              
            }
          } else {
            this.modals.create.isSave = false
          }
        })
        .catch(err => {
          this.modals.create.isCheckLoading = false
        })
      }, 200);

    },
    save() {
      if (this.timer.save) {
        clearTimeout(this.timer.save);
        this.timer.save = null;
      }
      this.timer.save = setTimeout(() => {
        // if(!this.modals.create.data.id && !this.modals.create.data.parent) {
        //   return this.$alertNotification("Parent node is required", "danger");
        // }

        const validate_fields = [
          // { key: 'street_no', name: 'Block Number/House Number'},
          // { key: 'street_name', name: 'Street name'},
          { key: 'property_type', name: 'Property type'},
        ]
        const is_validate = this.$validationData(validate_fields, this.modals.create.data)
        if(is_validate) return

        let pattern = /^[a-zA-Z0-9]+$/;
        let result = pattern.test(this.modals.create.data.street_no);
        if(!result) {
          return this.$alertNotification("Block Number/House Number must contain only letters and numbers", "danger");
        }

        if(this.modals.create.loading) return
        this.modals.create.loading = true

        let params = {
          id: this.modals.create.data.id,
          // street_name: this.modals.create.data.street_name,
          // street_no: this.modals.create.data.street_no,
          property_type_id: this.modals.create.data.property_type.id,
          property_type_text: this.modals.create.data.property_type.reference_value_text,
          contract_id: this.modals.create.data.contract_id,
          type: 'Building',
          country: 'Singapore',
          is_active: true,
          // parent_id: this.modals.create.data.parent.id,
          parent_id: this.ClientContractID.property_root_id,
          // name_parent: this.modals.create.data.parent.name,
          // name: (`${this.modals.create.data.street_no}, ${this.modals.create.data.street_name}, ${this.modals.create.data.postal_code}`).toUpperCase(),
          name: this.modals.create.data.name,
          // postal_code: this.modals.create.data.postal_code,
          property_root_id: this.ClientContractID.property_root_id,
          is_safety: true,
          geo_location: {
            latitude: this.modals.create.data.geo_location.latitude ? parseFloat(this.modals.create.data.geo_location.latitude) : null,
            longtitude: this.modals.create.data.geo_location.longtitude ? parseFloat(this.modals.create.data.geo_location.longtitude) : null
          },
        }

        let api = 'saveProperty';
        if(this.modals.create.data.id) {
          api = 'updateProperty';
        }

        this.$store.dispatch(`PropertyController/${api}`, params)
        .then(response => {
          this.modals.create.loading = this.modals.create.open = false
          this.$refs.gofixTable.reloadTableItems();
          this.$alertNotification(this.$notificationV2(this.modals.create.data.id ? 'editing' : 'adding', 'property'));
        })
        .catch(err => {
          this.modals.create.loading = false
        })
      }, 300);
    },
    async deleteProperty(){
      if(!this.modals.create.data.id) return;
      if (this.timer.delete) {
        clearTimeout(this.timer.delete);
        this.timer.delete = null;
      }
      this.timer.delete = setTimeout(() => {
        if(this.modals.confirm.loading) return
        this.modals.confirm.loading = true

        this.$store.dispatch('PropertyController/removeProperty', {
          id: this.modals.create.data.id,
          contract_id: this.modals.create.data.contract_id
        }).then(response => {
          this.modals.confirm.loading = this.modals.confirm.open = this.modals.create.open = false;
          this.$refs.gofixTable.reloadTableItems();
          this.$alertNotification(this.$notificationV2('deleting', 'property'));
        }).catch(err => {
          this.modals.confirm.loading = false;
        })
      }, 200);
    },
    // 
    onGroupSelected(is_existing) {
      this.modals.equipment.is_existing_group_lift = is_existing;
    },
    async showModalEquipment(property, equipment = null) {
      // if(!property.is_safety) return;
      if(!property.is_safety && equipment && equipment.id) return
      if(!this.modals.equipment.is_existing_group_lift) {
        return this.$alertNotification("No lift equipment group was found, therefore the equipment could not be created.", "danger");
      }

      this.modals.equipment.data = {};
      if(equipment && equipment.id) {
        let response = await this.$store.dispatch('EquipmentV2Controller/getEquipment', equipment.id)
        this.modals.equipment.data = response.data.data
      } else {
        this.modals.equipment.data = {
          location: {
            id: property.id,
            name: property.name
          }
        }
      }
      this.modals.equipment.open = true;
    }
  }
}
</script>
<style lang="scss" scoped>
  #modal-create-orders {
    .formNLTProperty {
      .gofixInput {
        &.gofixInputDisable {
          background: #c2c2c240;
        }
      }
    }
  }
</style>
